module.exports = __webpack_public_path__ + "img/harmonyOS_bg4.1e1f277d.jpg";